/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnplatforms3Inputs */

const en_downloadlinkscolumnplatforms3 = /** @type {(inputs: Downloadlinkscolumnplatforms3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone / Android / Other`)
};

const de_downloadlinkscolumnplatforms3 = /** @type {(inputs: Downloadlinkscolumnplatforms3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone / Android / Andere`)
};

/**
* | output |
* | --- |
* | "iPhone / Android / Other" |
*
* @param {Downloadlinkscolumnplatforms3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnplatforms3 = /** @type {((inputs?: Downloadlinkscolumnplatforms3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnplatforms3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnplatforms3(inputs)
	return de_downloadlinkscolumnplatforms3(inputs)
});
export { downloadlinkscolumnplatforms3 as "downloadLinksColumnPlatforms" }